<template>
  <div class="horarioAgendamento">
    <table class="table">
      <tr v-for="agenda in agendas" :key="agenda.hora">
        <td class="text-center bg-primary hora">
          <h3>{{ agenda.hora }}</h3>
        </td>
        <td>
          <span
            v-for="agendamento in agenda.agendamentos"
            :key="agendamento._id"
          >
            <span v-if="!agendamento.encaixe">
              <AgendamentoFicha
                :agendas="agendaCompleta"
                :agendamento="agendamento"
                :hora="agenda.hora"
                :data="data"
                :especialidade="especialidade"
                :unidade="unidade"
                class="agendamento_ficha"
                @atualizar="atualizar"
                @atualizarAgendamento="atualizarAgendamento"
              />
            </span>
          </span>
        </td>
        <td v-if="agenda.agendamentosInativos" class="agendamentosInativosCell">
          <Dropdown ref="dropdown" class="dropdown-form">
            <button type="button" class="btn btn-default dropdown-toggle">
              Ver desativados {{ agenda.agendamentosInativos.length }}
              <span class="caret"></span>
            </button>
            <template #dropdown>
              <div class="agendamentosInativos">
                <div v-for="(a, i) in agenda.agendamentosInativos" :key="a._id">
                  <div
                    class="agendamentosInativo"
                    :class="i % 2 === 0 ? 'white' : 'gray'"
                  >
                    <span
                      ><strong>{{ a.paciente.nome_social }}</strong></span
                    >
                    <span>{{ a.paciente.convenio.nome }}</span>
                    <span
                      >Guia(s):
                      {{
                        a.guia.length
                          ? a.guia.map((g) => g.numero).join(',')
                          : '-'
                      }}</span
                    >
                    <span>Profissional: {{ a.profissional.nome }}</span>
                    <span
                      >Desativado por {{ a.atualizadoPor }}, em
                      {{ a.desativadoEm }}</span
                    >
                  </div>
                </div>
              </div>
            </template>
          </Dropdown>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import AgendamentoFicha from './AgendamentoFicha'

export default {
  name: 'HorariosAgendamento',
  components: { AgendamentoFicha },
  props: {
    agendas: {
      type: Array,
      required: true,
    },
    agendaCompleta: {
      type: Array,
      required: true,
    },
    data: {
      type: String,
      required: true,
    },
    unidade: {
      type: String,
      required: true,
    },
    especialidade: {
      type: String,
      required: true,
    },
  },
  methods: {
    atualizar() {
      this.$emit('atualizar')
    },
    atualizarAgendamento(agendamento) {
      this.$emit('atualizarAgendamento', agendamento)
    },
  },
}
</script>

<style>
.agendamento_ficha {
  display: inline-block;
  width: auto;
  max-width: 210px;
}

.hora {
  width: 100px;
  border: 1px solid #ecf0f1;
}

.horarioAgendamento table,
.horarioAgendamento tr,
.horarioAgendamento td {
  padding: 0;
  vertical-align: middle;
}

.horarioAgendamento h3 {
  margin-top: 0;
}

.agendamentosInativosCell .dropdown-form .dropdown-menu {
  padding: 0;
}

.agendamentosInativos {
  display: flex;
  flex-flow: column;
}

.agendamentosInativo {
  display: flex;
  flex-flow: column;
  padding: 10px;
}

.agendamentosInativo.gray {
  background-color: #ecf0f1;
}
</style>
